import { useContext } from 'react';
import { TimeEntriesCacheContext, TimeEntriesCacheContextType } from '../contexts/TimeEntriesCache';

export function useTimeEntriesCache(): TimeEntriesCacheContextType {
  const context = useContext(TimeEntriesCacheContext);
  if (!context) {
    throw new Error('useTimeEntriesCache must be used within TimeEntriesCacheProvider');
  }
  return context;
}
